<template>
  <ReaderDrawer v-model="menuOpen">
    <template #header>
      <h2 class="font-medium text-lg">
        {{ t(key("header")) }}
      </h2>
    </template>
    <div v-if="!loggedIn">
      {{ t(key("login_required")) }}
    </div>
    <template v-else>
      <Tabs class="grid grid-cols-2 mx-2" :tabs="tabs" v-model="tab" />
      <NovelDrawerBookmarksBookmarks
        v-if="tab === 'bookmarks'"
        :titleId
        :chapterId
        :chapterSequence
        :paragraphOrder
        :solo
        @go="(pId, cId) => emit('go', pId, cId)"
        @edit="(bookmarks) => emit('editBookmarks', bookmarks)"
        @delete="(bookmarks) => emit('deleteBookmarks', bookmarks)"
      />
      <NovelDrawerBookmarksHighlights
        v-if="tab === 'highlights'"
        :titleId
        :chapterId
        :chapterSequence
        :paragraphOrder
        :solo
        @go="(pId) => emit('go', pId, chapterId)"
        @edit="(highlights) => emit('editHighlights', highlights)"
        @delete="(highlights) => emit('deleteHighlights', highlights)"
      />
    </template>
  </ReaderDrawer>
</template>

<script setup lang="ts">
import { getChapterSequenceForLang } from "~/src/reader/generic";
import type { NovelSettingsInterface } from "~/src/novel/reader";
import type { NovelBookmarkEntity } from "~/src/api";

const { t } = useI18n();
const key = useI18nKey(
  "components.novel.drawer.bookmarks.novelDrawerBookmarks",
);
const loggedIn = useIsLoggedIn();

const { chapterId, titleId, paragraphOrder, chapterSequence } = defineProps<{
  titleId: string;
  chapterId: string;
  chapterSequence: ReturnType<typeof getChapterSequenceForLang>;
  paragraphOrder?: string[];
  solo?: boolean;
}>();

const emit = defineEmits<{
  (e: "go", paragraphId: string, chapterId: string): void;
  (e: "editBookmarks", bookmarks: NovelBookmarkEntity[]): void;
  (e: "editHighlights", highlights: NovelBookmarkEntity[]): void;
  (e: "deleteBookmarks", bookmarks: NovelBookmarkEntity[]): void;
  (e: "deleteHighlights", highlights: NovelBookmarkEntity[]): void;
}>();

const secondaryMenuOpen = defineModel<
  NovelSettingsInterface["secondaryMenuOpen"]
>("secondaryMenuOpen", { default: false });
const menuOpen = computed({
  get: () => secondaryMenuOpen.value === "bookmarks",
  set: (v) => {
    if (v) secondaryMenuOpen.value = "bookmarks";
    else secondaryMenuOpen.value = false;
  },
});

const tab = ref("bookmarks");
const tabs = [
  { name: t(key("tabs.bookmarks")), value: "bookmarks" },
  { name: t(key("tabs.highlights")), value: "highlights" },
];
</script>
